module.exports = __webpack_public_path__ + "img/Fb.f5485d52.png";